// // client/src/components/TenantSettings.jsx
// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Building2,
//   Shield,
//   Palette,
//   Eye,
//   Bell,
//   Globe,
//   Users,
//   RefreshCw,
//   Sun,
//   Moon,
//   Monitor,
// } from "lucide-react";
// import AppFooter from "./AppFooter";
// import { FaSave, FaArrowLeft, FaHome } from "react-icons/fa";
// import { sessionRequestConfig, getSessionLocal, isEditRoleName } from '../services/sessionLocal';
// import PushNotificationSettings from './settings/PushNotificationSettings';

// const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

// export default function TenantSettings() {
//   const { tenant } = useParams();
//   const navigate = useNavigate();
//   const session = getSessionLocal();

//   // Check if user is admin/owner
//   const isAdmin = isEditRoleName(session.role) || ['owner', 'admin'].includes(session.role?.toLowerCase());

//   console.log('🔐 TenantSettings - User role check:', {
//     userId: session.userId,
//     tenantId: session.tenantId,
//     role: session.role,
//     isAdmin
//   });

//   // ==================== STATE ====================
//   // Tenant-level settings (admin only)
//   const [tenantData, setTenantData] = useState({
//     id: null,
//     companyname: "",
//     email: "",
//     phone: "",
//     address1: "",
//     address2: "",
//     city: "",
//     state: "",
//     zip: "",
//     logo: null,
//     waiver: null,
//     show_in_collab_directory: true,
//   });

//   // User-level settings
//   const [userSettings, setUserSettings] = useState({
//     theme: "system", // light | dark | system
//     reducedMotion: false,
//     language: "en-US", // ← Using full locale format
//     requiremfa: false,
//   });

//   // Collaboration state
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [searching, setSearching] = useState(false);

//   const [activeTab, setActiveTab] = useState("notifications"); // ← DEFAULT TO NOTIFICATIONS
//   const [busy, setBusy] = useState(false);
//   const [status, setStatus] = useState("");

//   // ==================== TABS CONFIGURATION ====================
//   const allTabs = [
//     // User settings (always visible)
//     { id: "notifications", label: "Notifications", icon: Bell, scope: "user" },
//     { id: "appearance", label: "Appearance", icon: Palette, scope: "user" },
//     { id: "accessibility", label: "Accessibility", icon: Eye, scope: "user" },
//     { id: "language", label: "Language", icon: Globe, scope: "user" },
//     { id: "security", label: "Security", icon: Shield, scope: "user" },
    
//     // Tenant settings (admin only)
//     { id: "company", label: "Company", icon: Building2, scope: "tenant", adminOnly: true },
//     { id: "collaboration", label: "Collaboration", icon: Users, scope: "tenant", adminOnly: true },
//   ];

//   // Filter tabs based on user role
//   const tabs = allTabs.filter(tab => !tab.adminOnly || isAdmin);

//   // ==================== LOAD DATA ====================
//   useEffect(() => {
//     loadAllSettings();
//   }, [tenant, session.userId]);

//   const loadAllSettings = async () => {
//     console.log('📡 Loading all settings...');
//     setBusy(true);
//     try {
//       // Load tenant settings if admin
//       if (isAdmin) {
//         await loadTenantSettings();
//       }
      
//       // Load user settings (always)
//       await loadUserSettings();
      
//     } catch (e) {
//       console.error("❌ Error loading settings:", e);
//       setStatus(`Error: ${e.response?.data?.message || e.message}`);
//       setTimeout(() => setStatus(""), 5000);
//     } finally {
//       setBusy(false);
//     }
//   };

//   const loadTenantSettings = async () => {
//     console.log('📡 Loading tenant settings...');
//     try {
//       // Use /profile endpoint - returns full tenant data, no auth required for reading
//       const res = await axios.get(
//         `${baseUrl}/api/tenants/${tenant}/profile`,
//         sessionRequestConfig()
//       );
      
//       console.log('✅ Tenant settings loaded:', res.data);
      
//       if (res.data?.success && res.data?.tenant) {
//         setTenantData(res.data.tenant);
//       }
//     } catch (e) {
//       console.error("❌ Error loading tenant settings:", e);
//       // Don't fail completely if tenant settings fail
//     }
//   };

//   const loadUserSettings = async () => {
//     console.log('📡 Loading user settings for user:', session.userId);
    
//     // Load language preference
//     try {
//       const langRes = await axios.get(
//         `${baseUrl}/api/users/${session.userId}/language`,
//         sessionRequestConfig()
//       );
//       console.log('✅ Language loaded:', langRes.data);
      
//       if (langRes.data?.success) {
//         setUserSettings(prev => ({ ...prev, language: langRes.data.language }));
//       }
//     } catch (e) {
//       console.error("❌ Error loading language:", e);
//       // Use default if fails
//     }

//     // Load other user preferences from localStorage
//     const saved = localStorage.getItem("userSettings");
//     if (saved) {
//       try {
//         const parsed = JSON.parse(saved);
//         console.log('📦 Loaded settings from localStorage:', parsed);
//         setUserSettings(prev => ({ ...prev, ...parsed }));
//       } catch (e) {
//         console.error("❌ Error parsing user settings:", e);
//       }
//     }
//   };

//   // ==================== SAVE HANDLERS ====================
//   const saveTenantSettings = async () => {
//     if (!isAdmin) {
//       setStatus("❌ You don't have permission to update company settings");
//       setTimeout(() => setStatus(""), 3000);
//       return;
//     }

//     if (!tenantData.companyname || !tenantData.email) {
//       setStatus("❌ Company name and email are required");
//       setTimeout(() => setStatus(""), 3000);
//       return;
//     }

//     console.log('💾 Saving tenant settings...');
//     setBusy(true);
//     try {
//       const res = await axios.put(
//         `${baseUrl}/api/tenants/${tenant}/settings`,
//         tenantData,
//         sessionRequestConfig()
//       );
      
//       console.log('✅ Tenant settings saved:', res.data);
      
//       if (res.data?.success) {
//         setStatus("✅ Company settings saved!");
//       }
//     } catch (e) {
//       console.error("❌ Error saving tenant settings:", e);
//       setStatus(`❌ Error: ${e.response?.data?.message || e.message}`);
//     } finally {
//       setBusy(false);
//       setTimeout(() => setStatus(""), 3000);
//     }
//   };

//   const saveUserSettings = async () => {
//     console.log('💾 Saving user settings...');
//     setBusy(true);
//     try {
//       // Save language to backend
//       await axios.put(
//         `${baseUrl}/api/users/${session.userId}/language`,
//         { language: userSettings.language },
//         sessionRequestConfig()
//       );

//       // Save other settings to localStorage
//       const { language, ...localSettings } = userSettings;
//       localStorage.setItem("userSettings", JSON.stringify(localSettings));
      
//       console.log('✅ User settings saved');
//       setStatus("✅ Settings saved successfully!");
//     } catch (e) {
//       console.error("❌ Error saving user settings:", e);
//       setStatus(`❌ Error: ${e.response?.data?.message || e.message}`);
//     } finally {
//       setBusy(false);
//       setTimeout(() => setStatus(""), 3000);
//     }
//   };

//   const handleSave = async () => {
//     const currentTab = tabs.find(t => t.id === activeTab);
    
//     if (currentTab?.scope === "tenant") {
//       await saveTenantSettings();
//     } else {
//       await saveUserSettings();
//     }
//   };

//   // ==================== COLLABORATION ====================
//   const searchTenants = async (query) => {
//     if (!query.trim() || query.length < 3) {
//       setSearchResults([]);
//       return;
//     }

//     console.log('🔍 Searching tenants:', query);
//     setSearching(true);
//     try {
//       const res = await axios.get(
//         `${baseUrl}/api/collab/${tenant}/searchTenants`,
//         { 
//           params: { query },
//           ...sessionRequestConfig()
//         }
//       );
      
//       console.log('✅ Search results:', res.data);
//       setSearchResults(res.data?.tenants || []);
//     } catch (e) {
//       console.error("❌ Search error:", e);
//       setSearchResults([]);
//     } finally {
//       setSearching(false);
//     }
//   };

//   const toggleCollabDirectory = async (enabled) => {
//     console.log('🔄 Toggling collab directory:', enabled);
//     try {
//       setTenantData(prev => ({ ...prev, show_in_collab_directory: enabled }));
      
//       await axios.patch(
//         `${baseUrl}/api/collab/${tenant}/settings`,
//         { showInCollabDirectory: enabled },
//         sessionRequestConfig()
//       );
      
//       console.log('✅ Collab directory updated');
//       setStatus("✅ Collaboration setting updated");
//       setTimeout(() => setStatus(""), 2000);
//     } catch (e) {
//       console.error("❌ Error updating collab setting:", e);
//       setStatus("❌ Error updating setting");
//       setTimeout(() => setStatus(""), 2000);
//       // Revert on error
//       setTenantData(prev => ({ ...prev, show_in_collab_directory: !enabled }));
//     }
//   };

//   // ==================== THEME HANDLING ====================
//   const handleThemeChange = (theme) => {
//     console.log('🎨 Changing theme to:', theme);
//     setUserSettings(prev => ({ ...prev, theme }));
    
//     if (theme === "dark") {
//       document.documentElement.classList.add("dark");
//     } else if (theme === "light") {
//       document.documentElement.classList.remove("dark");
//     } else {
//       const isDark = window.matchMedia?.("(prefers-color-scheme: dark)").matches;
//       document.documentElement.classList.toggle("dark", !!isDark);
//     }
//   };

//   const getAssetUrl = (path) => {
//     if (!path) return "";
//     if (path.startsWith("http")) return path;
//     return `${baseUrl}${path}`;
//   };

//   // ==================== TAB PANELS ====================
//   const NotificationsTab = () => (
//     <div>
//       <PushNotificationSettings 
//         showTestButton={true}
//         onStatusChange={(status) => {
//           console.log('🔔 Notification status changed:', status);
//         }}
//       />
//     </div>
//   );

//   const AppearanceTab = () => (
//     <div>
//       <div className="form-group">
//         <label>Theme</label>
//         <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//           {[
//             { value: "light", label: "Light", icon: Sun },
//             { value: "dark", label: "Dark", icon: Moon },
//             { value: "system", label: "System", icon: Monitor },
//           ].map(({ value, label, icon: Icon }) => (
//             <button
//               key={value}
//               type="button"
//               onClick={() => handleThemeChange(value)}
//               className={`btn ${
//                 userSettings.theme === value ? "btn-primary" : "btn-outline-primary"
//               }`}
//               style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
//             >
//               <Icon style={{ width: "16px", height: "16px" }} />
//               {label}
//             </button>
//           ))}
//         </div>
//       </div>
//     </div>
//   );

//   const AccessibilityTab = () => (
//     <div>
//       <div className="form-group">
//         <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//           <input
//             type="checkbox"
//             checked={userSettings.reducedMotion}
//             onChange={(e) => setUserSettings(prev => ({ ...prev, reducedMotion: e.target.checked }))}
//           />
//           <span>Reduce motion and animations</span>
//         </label>
//         <p style={{ fontSize: "14px", color: "#666", marginTop: "8px", marginLeft: "30px" }}>
//           Minimizes animations for users sensitive to motion
//         </p>
//       </div>
//     </div>
//   );

//   const LanguageTab = () => {
//     // Language codes matching backend format (xx-XX)
//     const languages = [
//       { code: 'en-US', name: 'English (US)' },
//       { code: 'en-GB', name: 'English (UK)' },
//       { code: 'es-ES', name: 'Español (España)' },
//       { code: 'es-MX', name: 'Español (México)' },
//       { code: 'fr-FR', name: 'Français' },
//       { code: 'de-DE', name: 'Deutsch' },
//       { code: 'it-IT', name: 'Italiano' },
//       { code: 'pt-BR', name: 'Português (Brasil)' },
//       { code: 'ja-JP', name: '日本語' },
//       { code: 'ko-KR', name: '한국어' },
//       { code: 'zh-CN', name: '中文 (简体)' },
//       { code: 'zh-TW', name: '中文 (繁體)' },
//     ];

//     return (
//       <div>
//         <div className="form-group">
//           <label htmlFor="language">Language</label>
//           <select
//             id="language"
//             className="form-control"
//             value={userSettings.language}
//             onChange={(e) => setUserSettings(prev => ({ ...prev, language: e.target.value }))}
//           >
//             {languages.map((lang) => (
//               <option key={lang.code} value={lang.code}>
//                 {lang.name}
//               </option>
//             ))}
//           </select>
//         </div>
//         <p style={{ fontSize: "14px", color: "#666", marginTop: "8px" }}>
//           Language changes take effect after refreshing the app
//         </p>
//       </div>
//     );
//   };

//   const SecurityTab = () => (
//     <div>
//       <div className="form-group">
//         <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//           <input
//             type="checkbox"
//             checked={userSettings.requiremfa}
//             onChange={(e) => setUserSettings(prev => ({ ...prev, requiremfa: e.target.checked }))}
//           />
//           <span>Enable Multi-Factor Authentication (MFA) for my account</span>
//         </label>
//         <p style={{ fontSize: "14px", color: "#666", marginTop: "8px", marginLeft: "30px" }}>
//           Add an extra layer of security to your account
//         </p>
//       </div>

//       <div className="form-group" style={{ marginTop: "20px" }}>
//         <h4 style={{ fontSize: "16px", marginBottom: "10px" }}>Password</h4>
//         <button
//           type="button"
//           className="btn btn-outline-primary"
//           onClick={() => {
//             setStatus("Password change functionality coming soon");
//             setTimeout(() => setStatus(""), 3000);
//           }}
//         >
//           Change Password
//         </button>
//       </div>
//     </div>
//   );

//   const CompanyTab = () => (
//     <div>
//       <div className="form-group">
//         <label htmlFor="companyname">Company Name *</label>
//         <input
//           id="companyname"
//           type="text"
//           className="form-control"
//           value={tenantData.companyname || ""}
//           onChange={(e) => setTenantData(prev => ({ ...prev, companyname: e.target.value }))}
//           disabled={busy}
//         />
//       </div>

//       <div className="form-group">
//         <label htmlFor="email">Company Email *</label>
//         <input
//           id="email"
//           type="email"
//           className="form-control"
//           value={tenantData.email || ""}
//           onChange={(e) => setTenantData(prev => ({ ...prev, email: e.target.value }))}
//           disabled={busy}
//         />
//       </div>

//       <div className="form-group">
//         <label htmlFor="phone">Phone</label>
//         <input
//           id="phone"
//           type="tel"
//           className="form-control"
//           value={tenantData.phone || ""}
//           onChange={(e) => setTenantData(prev => ({ ...prev, phone: e.target.value }))}
//           disabled={busy}
//         />
//       </div>

//       <div className="form-group">
//         <label htmlFor="address1">Address Line 1</label>
//         <input
//           id="address1"
//           type="text"
//           className="form-control"
//           value={tenantData.address1 || ""}
//           onChange={(e) => setTenantData(prev => ({ ...prev, address1: e.target.value }))}
//           disabled={busy}
//         />
//       </div>

//       <div className="form-group">
//         <label htmlFor="address2">Address Line 2</label>
//         <input
//           id="address2"
//           type="text"
//           className="form-control"
//           value={tenantData.address2 || ""}
//           onChange={(e) => setTenantData(prev => ({ ...prev, address2: e.target.value }))}
//           disabled={busy}
//         />
//       </div>

//       <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "10px" }}>
//         <div className="form-group">
//           <label htmlFor="city">City</label>
//           <input
//             id="city"
//             type="text"
//             className="form-control"
//             value={tenantData.city || ""}
//             onChange={(e) => setTenantData(prev => ({ ...prev, city: e.target.value }))}
//             disabled={busy}
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="state">State</label>
//           <input
//             id="state"
//             type="text"
//             className="form-control"
//             value={tenantData.state || ""}
//             onChange={(e) => setTenantData(prev => ({ ...prev, state: e.target.value }))}
//             disabled={busy}
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="zip">ZIP</label>
//           <input
//             id="zip"
//             type="text"
//             className="form-control"
//             value={tenantData.zip || ""}
//             onChange={(e) => setTenantData(prev => ({ ...prev, zip: e.target.value }))}
//             disabled={busy}
//           />
//         </div>
//       </div>
//     </div>
//   );

//   const CollaborationTab = () => (
//     <div>
//       <div className="form-group" style={{ marginBottom: "24px" }}>
//         <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//           <input
//             type="checkbox"
//             checked={tenantData.show_in_collab_directory}
//             onChange={(e) => toggleCollabDirectory(e.target.checked)}
//           />
//           <span>Show in collaboration directory</span>
//         </label>
//         <p style={{ fontSize: "14px", color: "#666", marginTop: "8px", marginLeft: "30px" }}>
//           Allow other tenants to discover and collaborate with you
//         </p>
//       </div>

//       <hr style={{ margin: "24px 0", border: "none", borderTop: "1px solid #e5e7eb" }} />

//       <div className="form-group">
//         <label>Search for tenants to collaborate with</label>
//         <input
//           type="text"
//           className="form-control"
//           placeholder="Search by name or email..."
//           value={searchQuery}
//           onChange={(e) => {
//             setSearchQuery(e.target.value);
//             if (e.target.value.length >= 3) {
//               searchTenants(e.target.value);
//             } else {
//               setSearchResults([]);
//             }
//           }}
//         />
//         {searchQuery.length > 0 && searchQuery.length < 3 && (
//           <small style={{ color: "#888", marginTop: "4px", display: "block" }}>
//             Enter at least 3 characters to search
//           </small>
//         )}
//         {searchQuery.length >= 3 && (
//           <button
//             type="button"
//             className="btn btn-primary"
//             onClick={() => searchTenants(searchQuery)}
//             disabled={searching}
//             style={{ width: "100%", marginTop: "8px" }}
//           >
//             {searching ? "Searching..." : "Search"}
//           </button>
//         )}
//       </div>

//       {searchResults.length > 0 && (
//         <div style={{ 
//           marginTop: "16px", 
//           border: "1px solid #e5e7eb", 
//           borderRadius: "8px",
//           maxHeight: "300px",
//           overflowY: "auto"
//         }}>
//           {searchResults.map((t) => (
//             <div
//               key={t.id}
//               style={{
//                 padding: "12px",
//                 borderBottom: "1px solid #e5e7eb",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center"
//               }}
//             >
//               <div>
//                 <div style={{ fontWeight: "600" }}>{t.name}</div>
//                 <div style={{ fontSize: "12px", color: "#666" }}>{t.email}</div>
//               </div>
//               <button
//                 type="button"
//                 className="btn btn-sm btn-outline-primary"
//                 onClick={() => {
//                   // TODO: Implement invite functionality
//                   console.log("Invite tenant:", t.id);
//                   setStatus(`Invite functionality coming soon for ${t.name}`);
//                   setTimeout(() => setStatus(""), 3000);
//                 }}
//               >
//                 Invite
//               </button>
//             </div>
//           ))}
//         </div>
//       )}

//       {searchQuery.length >= 3 && searchResults.length === 0 && !searching && (
//         <p style={{ marginTop: "12px", color: "#666", fontSize: "14px", textAlign: "center" }}>
//           No tenants found matching "{searchQuery}"
//         </p>
//       )}
//     </div>
//   );

//   // ==================== RENDER ====================
//   if (busy && !tenantData.id && !userSettings.language) {
//     return (
//       <div className="container" style={{ padding: "40px 20px", textAlign: "center" }}>
//         <RefreshCw style={{ width: "40px", height: "40px", animation: "spin 1s linear infinite" }} />
//         <p style={{ marginTop: "16px" }}>Loading settings...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="container">
//       {/* Header */}
//       <div style={{ textAlign: "center", marginBottom: "20px", position: "relative" }}>
//         <h2 className="hdr hdr--primary hdr--lg">Settings</h2>
//         {busy && (
//           <RefreshCw 
//             style={{ 
//               width: "20px", 
//               height: "20px", 
//               animation: "spin 1s linear infinite",
//               position: "absolute",
//               right: "10px",
//               top: "50%",
//               transform: "translateY(-50%)"
//             }} 
//           />
//         )}
//       </div>

//       {/* Status Message */}
//       {status && (
//         <div
//           style={{
//             marginBottom: "20px",
//             padding: "12px",
//             borderRadius: "8px",
//             backgroundColor: status.includes("❌") ? "#fee2e2" : "#d1fae5",
//             color: status.includes("❌") ? "#991b1b" : "#065f46",
//             fontSize: "14px",
//           }}
//         >
//           {status}
//         </div>
//       )}

//       {/* Tabs */}
//       <div style={{ 
//         display: "grid", 
//         gridTemplateColumns: "repeat(2, 1fr)", 
//         gap: "8px", 
//         marginBottom: "20px" 
//       }}>
//         {tabs.map(({ id, label, icon: Icon }) => (
//           <button
//             key={id}
//             type="button"
//             onClick={() => setActiveTab(id)}
//             className={`btn btn-sm ${activeTab === id ? "btn-primary" : "btn-outline-primary"}`}
//             style={{ 
//               display: "flex", 
//               alignItems: "center", 
//               justifyContent: "center", 
//               gap: "6px",
//               padding: "10px 8px",
//               fontSize: "13px",
//               minHeight: "40px"
//             }}
//           >
//             <Icon style={{ width: "16px", height: "16px", flexShrink: 0 }} />
//             <span style={{ lineHeight: "1.2" }}>{label}</span>
//           </button>
//         ))}
//       </div>

//       {/* Tab Content */}
//       <div style={{ marginBottom: "80px" }}>
//         {activeTab === "notifications" && <NotificationsTab />}
//         {activeTab === "appearance" && <AppearanceTab />}
//         {activeTab === "accessibility" && <AccessibilityTab />}
//         {activeTab === "language" && <LanguageTab />}
//         {activeTab === "security" && <SecurityTab />}
//         {activeTab === "company" && isAdmin && <CompanyTab />}
//         {activeTab === "collaboration" && isAdmin && <CollaborationTab />}
//       </div>

//       {/* Footer */}
//       <AppFooter
//         buttons={[
//           {
//             icon: <FaArrowLeft />,
//             label: "Back",
//             onClick: () => navigate(-1),
//           },
//           {
//             icon: <FaHome />,
//             label: "Home",
//             onClick: () => navigate(`/${tenant}/dashboard`),
//           },
//           {
//             icon: busy ? <RefreshCw className="animate-spin" /> : <FaSave />,
//             label: busy ? "Saving..." : "Save",
//             onClick: handleSave,
//             disabled: busy,
//           },
//         ]}
//       />
//     </div>
//   );
// }


// client/src/components/TenantSettings.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Building2, Shield, ShieldCheck, Palette, Eye, Bell, Globe,
  Users, RefreshCw, Sun, Moon, Monitor, Sparkles, DollarSign,
  ChevronDown, ChevronRight, Check, X,
  Upload, Trash2, FileText, Paperclip, Replace,
  Settings as SettingsIcon, Heart, MessageCircle, Ticket, Activity,
} from "lucide-react";
import AppFooter from "./AppFooter";
import { FaSave, FaArrowLeft, FaHome } from "react-icons/fa";
import { sessionRequestConfig, getSessionLocal, isEditRoleName } from '../services/sessionLocal';
import PushNotificationSettings from './settings/PushNotificationSettings';
import TenantTransactions from './settings/TenantTransactions';
import PaymentProviderSettings from './payment/PaymentProviderSettings';
import ChangePasswordForm from './user/ChangePasswordForm';
import i18n from '../i18n/config';
import { getCurrencyOptions, DEFAULT_CURRENCY } from '../utils/currencyUtils';

const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

// Defined outside the component so it's never recreated on render
const LANGUAGES = [
  { code: 'en-US', name: 'English (US)' },
  { code: 'en-GB', name: 'English (UK)' },
  { code: 'es-ES', name: 'Español (España)' },
  { code: 'es-MX', name: 'Español (México)' },
  { code: 'fr-FR', name: 'Français' },
  { code: 'de-DE', name: 'Deutsch' },
  { code: 'it-IT', name: 'Italiano' },
  { code: 'pt-BR', name: 'Português (Brasil)' },
  { code: 'ja-JP', name: '日本語' },
  { code: 'ko-KR', name: '한국어' },
  { code: 'zh-CN', name: '中文 (简体)' },
  { code: 'zh-TW', name: '中文 (繁體)' },
  { code: 'ar-SA', name: 'العربية (السعودية)' },
  { code: 'am-ET', name: 'አማርኛ (ኢትዮጵያ)' },
  { code: 'ar-SA', name: 'العربية (السعودية)' },
  { code: 'ha-NG', name: 'Hausa (Nigeria)' },
  { code: 'he-IL', name: 'עברית (ישראל)' },
  { code: 'sw-KE', name: 'Swahili (Kenya)' },
];

// ─── ConfigSection ──────────────────────────────────────────────────────────
// Collapsible section used inside the Configurations tab. Defined at module
// scope so React keeps a stable component identity across renders (otherwise
// inputs nested inside lose focus on every keystroke).
function ConfigSection({ icon: Icon, title, expanded, onToggle, children }) {
  return (
    <div style={{
      marginBottom: "12px",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      overflow: "hidden",
    }}>
      <button
        type="button"
        onClick={onToggle}
        className="bg-light"
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "12px 16px",
          border: "none",
          cursor: "pointer",
          color: "#253866",
          fontWeight: 600,
          fontSize: "14px",
          textAlign: "left",
        }}
      >
        {expanded
          ? <ChevronDown style={{ width: 16, height: 16, flexShrink: 0 }} />
          : <ChevronRight style={{ width: 16, height: 16, flexShrink: 0 }} />}
        {Icon && <Icon style={{ width: 16, height: 16, flexShrink: 0 }} />}
        <span>{title}</span>
      </button>
      {expanded && (
        <div className="bg-white" style={{ padding: "16px", borderTop: "1px solid #e5e7eb" }}>
          {children}
        </div>
      )}
    </div>
  );
}

// ─── Role Access Configuration ──────────────────────────────────────────────
const ROLES = ['owner', 'admin', 'manager', 'operator', 'contributor'];

const RESOURCE_SECTIONS = [
  {
    label: 'Core Resources',
    resources: [
      { key: 'members',       label: 'Members',          actions: ['view', 'add', 'update', 'delete'] },
      { key: 'events',        label: 'Events',           actions: ['view', 'add', 'update', 'delete'] },
      { key: 'eventItems',    label: 'Event Items',      actions: ['view', 'add', 'update', 'delete'] },
      { key: 'eventDetailTask', label: 'Event Detail Task', actions: ['view', 'add', 'update', 'delete'] },
    ],
  },
  {
    label: 'Operations',
    resources: [
      { key: 'analytics',     label: 'Analytics',        actions: ['view', 'update'] },
      { key: 'posting',       label: 'Posting',          actions: ['view', 'submit', 'schedule', 'update', 'delete'] },
    ],
  },
  {
    label: 'Administration',
    resources: [
      { key: 'tenantUsers',   label: 'Tenant Users',     actions: ['view', 'add', 'update', 'delete'] },
      { key: 'integrations',  label: 'Integrations',     actions: ['view', 'add', 'update', 'delete'] },
    ],
  },
  {
    label: 'Settings',
    resources: [
      { key: 'tenantSettings',          label: 'General',        actions: ['view', 'add', 'update', 'delete'] },
      { key: 'tenantSettingsCompany',    label: 'Company',        actions: ['view', 'add', 'update', 'delete'] },
      { key: 'tenantSettingsVenmo',      label: 'Venmo',          actions: ['view', 'add', 'update', 'delete'] },
      { key: 'tenantSettingsCollab',     label: 'Collaboration',  actions: ['view', 'add', 'update', 'delete'] },
      { key: 'tenantSettingsRoleAccess', label: 'Role Access',    actions: ['view', 'add', 'update', 'delete'] },
    ],
  },
];

// Flat list for iteration
const ALL_RESOURCES = RESOURCE_SECTIONS.flatMap(s => s.resources);

// Build default permissions — owner/admin get everything, manager most, operator minimal
function buildDefaultPermissions() {
  const perms = {};
  for (const role of ROLES) {
    perms[role] = {};
    for (const res of ALL_RESOURCES) {
      perms[role][res.key] = {};
      for (const action of res.actions) {
        if (role === 'owner' || role === 'admin') {
          perms[role][res.key][action] = true;
        } else if (role === 'manager') {
          // Managers: full access to core & operations, limited on admin/settings
          const isAdminResource = ['tenantUsers', 'integrations'].includes(res.key);
          const isSettingsResource = res.key.startsWith('tenantSettings');
          if (isSettingsResource) {
            perms[role][res.key][action] = action === 'view';
          } else if (isAdminResource) {
            perms[role][res.key][action] = ['view', 'add', 'update'].includes(action);
          } else {
            perms[role][res.key][action] = true;
          }
        } else if (role === 'operator') {
          // Operator: view-only on most, can add/update on core resources
          const isCoreResource = ['members', 'events', 'eventItems', 'eventDetailTask'].includes(res.key);
          if (isCoreResource) {
            perms[role][res.key][action] = ['view', 'add', 'update'].includes(action);
          } else if (res.key === 'posting') {
            perms[role][res.key][action] = ['view', 'submit'].includes(action);
          } else {
            perms[role][res.key][action] = action === 'view';
          }
        } else {
          // Contributor: view events, upload media (event items) — nothing else
          if (res.key === 'events') {
            perms[role][res.key][action] = action === 'view';
          } else if (res.key === 'eventItems') {
            perms[role][res.key][action] = ['view', 'add'].includes(action);
          } else {
            perms[role][res.key][action] = false;
          }
        }
      }
    }
  }
  return perms;
}

const ACTION_LABELS = {
  view: 'View', add: 'Add', update: 'Update', delete: 'Delete',
  submit: 'Submit', schedule: 'Schedule',
};

export default function TenantSettings() {
  const { tenant } = useParams();
  const navigate = useNavigate();
  const session = getSessionLocal();
  const isAdmin = isEditRoleName(session.role) || ['owner', 'admin'].includes(session.role?.toLowerCase());

  const [tenantData, setTenantData] = useState({
    id: null, companyname: "", email: "", phone: "",
    address1: "", address2: "", city: "", state: "", zip: "",
    currency: DEFAULT_CURRENCY,
    logo: null, waiver: null, show_in_collab_directory: true, public_event_history_enabled: false,
    public_history_require_login: false, public_history_access_fee: 0,
    public_history_allow_likes: true, public_history_allow_comments: true,
    venmo_stripe_enabled: false, venmo_direct_enabled: false,
    venmo_username: "", venmo_display_name: "",
    venmo_event_button_enabled: false, venmo_default_note: "", venmo_default_amount: 0,
    paid_raffle_entries_enabled: false,
    tax_collection_enabled: false,
  });

  const currencyOptions = getCurrencyOptions();

  // Lazy-initialize from localStorage so the theme buttons start in the
  // correct "active" state on mount (and on every remount when the user
  // re-navigates into Settings). The async loadUserSettings effect still
  // runs to pull language from the server, but localStorage is the source
  // of truth for theme + reducedMotion + requiremfa across sessions.
  const [userSettings, setUserSettings] = useState(() => {
    const defaults = { theme: "minimal", reducedMotion: false, language: "en-US", requiremfa: false, mediaView: "grid" };
    try {
      const raw = typeof localStorage !== 'undefined' && localStorage.getItem("userSettings");
      if (!raw) return defaults;
      const parsed = JSON.parse(raw);
      return { ...defaults, ...(parsed && typeof parsed === 'object' ? parsed : {}) };
    } catch {
      return defaults;
    }
  });

  // Role access permissions (persisted to localStorage)
  const [rolePermissions, setRolePermissions] = useState(() => {
    try {
      const raw = localStorage.getItem("roleAccessPermissions");
      if (raw) return JSON.parse(raw);
    } catch { /* ignore */ }
    return buildDefaultPermissions();
  });
  const [selectedRole, setSelectedRole] = useState('admin');
  const [expandedSections, setExpandedSections] = useState(() =>
    RESOURCE_SECTIONS.reduce((acc, s) => ({ ...acc, [s.label]: true }), {})
  );

  const [searchQuery, setSearchQuery]   = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searching, setSearching]       = useState(false);
  const [activeTab, setActiveTab]       = useState("configurations");
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [expandedConfigSections, setExpandedConfigSections] = useState({
    notifications: true,
    accessibility: false,
    language: false,
    collaboration: false,
    publicHistory: false,
    raffles: false,
  });
  const [busy, setBusy]                 = useState(false);
  const [status, setStatus]             = useState("");

  // Danger Zone (owner-only account/tenant deletion)
  const [tenantDeleteConfirm, setTenantDeleteConfirm] = useState("");
  const [tenantDeletePassword, setTenantDeletePassword] = useState("");
  const [tenantDeleteBusy, setTenantDeleteBusy]       = useState(false);
  const [ownerDeleteConfirm, setOwnerDeleteConfirm]   = useState("");
  const [ownerDeletePassword, setOwnerDeletePassword] = useState("");
  const [ownerDeleteBusy, setOwnerDeleteBusy]         = useState(false);
  const [ownedTenantsCount, setOwnedTenantsCount]     = useState(null);

  // Tenant file attachments (company tab)
  const [tenantFiles, setTenantFiles]       = useState([]);
  const [filesBusy, setFilesBusy]           = useState(false);
  const [replacingFileId, setReplacingFileId] = useState(null);
  const [dragOver, setDragOver]             = useState(false);

  // Only the literal tenant owner (t_tenant.ownerid === my id) — not just
  // any admin — may see the Danger Zone. A plain admin employee also gets
  // role='admin' on their JWT (authRoutes.js hardcodes it for owner logins
  // too), so isAdmin alone can't distinguish them; ownerid comparison can.
  const isOwner = Number(tenantData?.ownerid) === Number(session.userId) && !!session.userId;

  const allTabs = [
    { id: "configurations", label: "Configurations", icon: SettingsIcon, adminOnly: false },
    { id: "appearance",     label: "Appearance",     icon: Palette,      adminOnly: false },
    { id: "security",       label: "Security",       icon: Shield,       adminOnly: false },
    { id: "company",        label: "Company",        icon: Building2,    adminOnly: true },
    { id: "transactions",   label: "Transactions",   icon: Activity,     adminOnly: true },
    { id: "roleAccess",     label: "Role Access",    icon: ShieldCheck,  adminOnly: true },
    { id: "payments",       label: "Payments",       icon: DollarSign,   adminOnly: true },
    { id: "dangerZone",     label: "Danger Zone",    icon: Trash2,       adminOnly: true, ownerOnly: true },
  ];
  const tabs = allTabs.filter(t => (!t.adminOnly || isAdmin) && (!t.ownerOnly || isOwner));

  useEffect(() => { loadAllSettings(); }, [tenant, session.userId]); // eslint-disable-line

  useEffect(() => {
    if (activeTab !== "dangerZone" || !isOwner) return;
    axios.get(`${baseUrl}/api/users/my-tenants`, sessionRequestConfig())
      .then(res => setOwnedTenantsCount(Array.isArray(res.data?.tenants) ? res.data.tenants.length : null))
      .catch(() => setOwnedTenantsCount(null));
  }, [activeTab, isOwner]); // eslint-disable-line

  const loadAllSettings = async () => {
    setBusy(true);
    try {
      if (isAdmin) {
        await loadTenantSettings();
        loadTenantFiles();
      }
      await loadUserSettings();
    } catch (e) {
      setStatus(`❌ Error: ${e.response?.data?.message || e.message}`);
      setTimeout(() => setStatus(""), 5000);
    } finally {
      setBusy(false);
    }
  };

  const loadTenantSettings = async () => {
    try {
      const res = await axios.get(`${baseUrl}/api/tenants/${tenant}/profile`, sessionRequestConfig());
      if (res.data?.success && res.data?.tenant) setTenantData(res.data.tenant);
    } catch (e) {
      console.error("❌ Error loading tenant settings:", e);
    }
  };

  const loadTenantFiles = async () => {
    try {
      const res = await axios.get(`${baseUrl}/api/tenants/${tenant}/files`, sessionRequestConfig());
      if (res.data?.success) setTenantFiles(res.data.files || []);
    } catch (e) {
      console.error("❌ Error loading tenant files:", e);
    }
  };

  const uploadTenantFiles = async (fileList) => {
    const files = Array.from(fileList || []).filter(Boolean);
    if (files.length === 0) return;
    const cfg = sessionRequestConfig();
    const formData = new FormData();
    for (const f of files) formData.append("files", f);
    setFilesBusy(true);
    try {
      const res = await axios.post(
        `${baseUrl}/api/tenants/${tenant}/files`,
        formData,
        { ...cfg, headers: { ...cfg.headers, "Content-Type": "multipart/form-data" } }
      );
      if (res.data?.success) {
        setTenantFiles(prev => [...(res.data.files || []), ...prev]);
        setStatus(`✅ Uploaded ${res.data.files?.length || 0} file(s)`);
      }
    } catch (e) {
      setStatus(`❌ ${e.response?.data?.message || e.message}`);
    } finally {
      setFilesBusy(false);
      setTimeout(() => setStatus(""), 3000);
    }
  };

  const replaceTenantFile = async (fileId, file) => {
    if (!file) return;
    const cfg = sessionRequestConfig();
    const formData = new FormData();
    formData.append("file", file);
    setFilesBusy(true);
    try {
      const res = await axios.put(
        `${baseUrl}/api/tenants/${tenant}/files/${fileId}`,
        formData,
        { ...cfg, headers: { ...cfg.headers, "Content-Type": "multipart/form-data" } }
      );
      if (res.data?.success && res.data.file) {
        setTenantFiles(prev => prev.map(f => f.id === fileId ? { ...f, ...res.data.file } : f));
        setStatus("✅ File replaced");
      }
    } catch (e) {
      setStatus(`❌ ${e.response?.data?.message || e.message}`);
    } finally {
      setFilesBusy(false);
      setReplacingFileId(null);
      setTimeout(() => setStatus(""), 3000);
    }
  };

  const deleteTenantFile = async (fileId) => {
    if (!window.confirm("Delete this file? This cannot be undone.")) return;
    setFilesBusy(true);
    try {
      const res = await axios.delete(`${baseUrl}/api/tenants/${tenant}/files/${fileId}`, sessionRequestConfig());
      if (res.data?.success) {
        setTenantFiles(prev => prev.filter(f => f.id !== fileId));
        setStatus("✅ File deleted");
      }
    } catch (e) {
      setStatus(`❌ ${e.response?.data?.message || e.message}`);
    } finally {
      setFilesBusy(false);
      setTimeout(() => setStatus(""), 3000);
    }
  };

  // Strip the "tenant_{tenantId}_{timestamp}-{rand}_" prefix the server adds
  const displayFileName = (relativePath) => {
    const base = (relativePath || "").split("/").pop() || "";
    return base.replace(/^tenant_\d+_\d+-\d+_/, "");
  };

  const isImageType = (mime) => /^image\//i.test(mime || "");

  const loadUserSettings = async () => {
    if (!session.userId) {
      console.warn('⚠️ No userId in session — skipping user settings load. Please log out and back in.');
      return;
    }
    try {
      const res = await axios.get(`${baseUrl}/api/users/${session.userId}/language`, sessionRequestConfig());
      if (res.data?.success) {
        setUserSettings(prev => ({ ...prev, language: res.data.language }));
        await i18n.changeLanguage(res.data.language);
      }
    } catch (e) {
      console.error("❌ Error loading language:", e);
    }
    const saved = localStorage.getItem("userSettings");
    if (saved) {
      try { setUserSettings(prev => ({ ...prev, ...JSON.parse(saved) })); } catch {}
    }
  };

  const saveRolePermissions = () => {
    localStorage.setItem("roleAccessPermissions", JSON.stringify(rolePermissions));
    setStatus("Role access permissions saved!");
    setTimeout(() => setStatus(""), 3000);
  };

  const handleSave = async () => {
    if (activeTab === "roleAccess") {
      saveRolePermissions();
      return;
    }
    // Transactions is a read-only report — nothing to persist.
    if (activeTab === "transactions") return;
    if (activeTab === "configurations") {
      // Configurations bundles both user-level (language, accessibility, notifications)
      // and tenant-level (public history, allow likes/comments) settings.
      await saveUserSettings();
      if (isAdmin) await saveTenantSettings();
      return;
    }
    const currentTab = tabs.find(t => t.id === activeTab);
    if (currentTab?.adminOnly) await saveTenantSettings();
    else await saveUserSettings();
  };

  const saveTenantSettings = async () => {
    if (!tenantData.companyname || !tenantData.email) {
      setStatus("❌ Company name and email are required");
      setTimeout(() => setStatus(""), 3000);
      return;
    }
    setBusy(true);
    try {
      const res = await axios.put(`${baseUrl}/api/tenants/${tenant}/settings`, tenantData, sessionRequestConfig());
      if (res.data?.success) setStatus("✅ Company settings saved!");
    } catch (e) {
      setStatus(`❌ Error: ${e.response?.data?.message || e.message}`);
    } finally {
      setBusy(false);
      setTimeout(() => setStatus(""), 3000);
    }
  };

  const saveUserSettings = async () => {
    setBusy(true);
    try {
      // Always apply language locally — works regardless of session state
      await i18n.changeLanguage(userSettings.language);
      localStorage.setItem('i18nextLng', userSettings.language);
      const { language, ...localSettings } = userSettings;
      localStorage.setItem("userSettings", JSON.stringify(localSettings));

      // Only persist to server if we have a valid userId
      if (session.userId && session.userId !== 'null') {
        await axios.put(
          `${baseUrl}/api/users/${session.userId}/language`,
          { language: userSettings.language },
          sessionRequestConfig()
        );
        setStatus("✅ Settings saved successfully!");
      } else {
        console.warn('⚠️ Language saved locally only — no userId in session.');
        setStatus("✅ Language applied! Log out and back in to save to your account.");
      }
    } catch (e) {
      setStatus(`❌ Error: ${e.response?.data?.message || e.message}`);
    } finally {
      setBusy(false);
      setTimeout(() => setStatus(""), 3000);
    }
  };

  const handleDeleteTenant = async () => {
    if (tenantDeleteConfirm !== tenantData.companyname || !tenantDeletePassword) return;
    if (!window.confirm(
      `This permanently deactivates "${tenantData.companyname}" and cancels its subscription immediately. This cannot be undone from the app. Continue?`
    )) {
      return;
    }
    setTenantDeleteBusy(true);
    try {
      await axios.post(
        `${baseUrl}/api/tenants/${tenant}/delete`,
        { password: tenantDeletePassword, confirmText: tenantDeleteConfirm },
        sessionRequestConfig()
      );
      navigate('/login');
    } catch (e) {
      setStatus(`❌ ${e.response?.data?.error || e.message}`);
      setTimeout(() => setStatus(""), 4000);
    } finally {
      setTenantDeleteBusy(false);
    }
  };

  // The confirm text is the owner's own account email — we don't fetch or
  // display it (that would mean a new endpoint just to echo it back), the
  // user is expected to know their own login email. The server is the
  // source of truth for the match; a mismatch comes back as a status error.
  const handleDeleteOwnerAccount = async () => {
    if (!ownerDeleteConfirm || !ownerDeletePassword) return;
    const extra = ownedTenantsCount > 1
      ? ` This will also permanently deactivate all ${ownedTenantsCount} businesses you own.`
      : '';
    if (!window.confirm(`This permanently deletes your owner account.${extra} This cannot be undone from the app. Continue?`)) {
      return;
    }
    setOwnerDeleteBusy(true);
    try {
      await axios.delete(`${baseUrl}/api/auth/owner-account`, {
        ...sessionRequestConfig(),
        data: { password: ownerDeletePassword, confirmText: ownerDeleteConfirm },
      });
      navigate('/login');
    } catch (e) {
      setStatus(`❌ ${e.response?.data?.message || e.message}`);
      setTimeout(() => setStatus(""), 4000);
    } finally {
      setOwnerDeleteBusy(false);
    }
  };

  const searchTenants = async (query) => {
    if (!query.trim() || query.length < 3) { setSearchResults([]); return; }
    setSearching(true);
    try {
      // sessionRequestConfig() has its own `params` (tenantId/meId/roleId/role) —
      // spreading it after `params: { query }` would overwrite that object
      // wholesale and silently drop `query` from the request.
      const cfg = sessionRequestConfig();
      const res = await axios.get(
        `${baseUrl}/api/collab/${tenant}/searchTenants`,
        { ...cfg, params: { ...cfg.params, query } }
      );
      setSearchResults(res.data?.tenants || []);
    } catch (e) {
      console.error("❌ Search error:", e);
      setSearchResults([]);
    } finally {
      setSearching(false);
    }
  };

  const toggleCollabDirectory = async (enabled) => {
    setTenantData(prev => ({ ...prev, show_in_collab_directory: enabled }));
    try {
      await axios.patch(`${baseUrl}/api/collab/${tenant}/settings`, { showInCollabDirectory: enabled }, sessionRequestConfig());
      setStatus("✅ Collaboration setting updated");
      setTimeout(() => setStatus(""), 2000);
    } catch (e) {
      setStatus("❌ Error updating setting");
      setTimeout(() => setStatus(""), 2000);
      setTenantData(prev => ({ ...prev, show_in_collab_directory: !enabled }));
    }
  };

  const handleThemeChange = (theme) => {
    setUserSettings(prev => {
      const next = { ...prev, theme };
      // Persist immediately so other tabs / a refresh pick up the change
      // without waiting for the user to hit Save.
      try {
        const { language, ...local } = next;
        localStorage.setItem("userSettings", JSON.stringify(local));
      } catch { /* ignore */ }
      return next;
    });
    const root = document.documentElement;
    root.classList.remove("theme-light", "theme-dark", "theme-minimal");
    if (theme === "dark") {
      root.classList.add("theme-dark");
    } else if (theme === "light") {
      root.classList.add("theme-light");
    } else if (theme === "minimal") {
      root.classList.add("theme-minimal");
    } else {
      const prefersDark = window.matchMedia?.("(prefers-color-scheme: dark)").matches;
      root.classList.add(prefersDark ? "theme-dark" : "theme-light");
    }
  };

  // ─── RENDER ───────────────────────────────────────────────────────────────
  // All tab content is rendered as inline JSX below — never as inner function
  // components (const Foo = () => ...) defined inside the parent. Inner function
  // components get a new identity every render, so React unmounts/remounts them
  // on every state change, which kills input focus after every keystroke.

  if (busy && !tenantData.id && !userSettings.language) {
    return (
      <div className="container" style={{ padding: "40px 20px", textAlign: "center" }}>
        <RefreshCw style={{ width: "40px", height: "40px", animation: "spin 1s linear infinite" }} />
        <p style={{ marginTop: "16px" }}>Loading settings...</p>
      </div>
    );
  }

  return (
    <div className="container">

      {/* Header */}
      <div style={{ textAlign: "center", marginBottom: "20px", position: "relative" }}>
        <h2 className="hdr hdr--primary hdr--lg">Settings</h2>
        {busy && (
          <RefreshCw style={{
            width: "20px", height: "20px", animation: "spin 1s linear infinite",
            position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)"
          }} />
        )}
      </div>

      {/* Desktop inline action bar (replaces footer on desktop) */}
      <div className="desktop-action-bar">
        <button type="button" onClick={() => navigate(-1)}>
          <FaArrowLeft /> Back
        </button>
        <button type="button" onClick={() => navigate(`/${tenant}/dashboard`)}>
          <FaHome /> Home
        </button>
        <button type="button" className="btn-primary-action" onClick={handleSave} disabled={busy}>
          {busy ? <RefreshCw className="animate-spin" /> : <FaSave />} {busy ? "Saving..." : "Save"}
        </button>
      </div>

      {/* Status */}
      {status && (
        <div style={{
          marginBottom: "20px", padding: "12px", borderRadius: "8px", fontSize: "14px",
          backgroundColor: status.includes("❌") ? "#fee2e2" : "#d1fae5",
          color: status.includes("❌") ? "#991b1b" : "#065f46",
        }}>
          {status}
        </div>
      )}

      {/* Tab Buttons */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px", marginBottom: "20px" }}>
        {tabs.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            type="button"
            onClick={() => setActiveTab(id)}
            className={`btn btn-sm ${activeTab === id ? "btn-primary" : "btn-outline-primary"}`}
            style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", padding: "10px 8px", fontSize: "13px", minHeight: "40px" }}
          >
            <Icon style={{ width: "16px", height: "16px", flexShrink: 0 }} />
            <span style={{ lineHeight: "1.2" }}>{label}</span>
          </button>
        ))}
      </div>

      {/* ── Tab Content ── */}
      <div style={{ marginBottom: "80px" }}>

        {activeTab === "configurations" && (
          <div>
            <p className="text-muted" style={{ fontSize: "0.9rem", marginBottom: "16px" }}>
              All app preferences and public-facing event-history settings in one place.
            </p>

            {/* Notifications */}
            <ConfigSection
              id="notifications"
              icon={Bell}
              title="Notifications"
              expanded={expandedConfigSections.notifications}
              onToggle={() => setExpandedConfigSections(prev => ({ ...prev, notifications: !prev.notifications }))}
            >
              <PushNotificationSettings
                showTestButton={true}
                onStatusChange={(s) => console.log('🔔 Notification status:', s)}
              />
            </ConfigSection>

            {/* Accessibility */}
            <ConfigSection
              id="accessibility"
              icon={Eye}
              title="Accessibility"
              expanded={expandedConfigSections.accessibility}
              onToggle={() => setExpandedConfigSections(prev => ({ ...prev, accessibility: !prev.accessibility }))}
            >
              <div className="form-group" style={{ marginBottom: "0" }}>
                <label style={{ display: "flex", alignItems: "flex-start", gap: "12px", cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={userSettings.reducedMotion}
                    onChange={(e) => setUserSettings(prev => ({ ...prev, reducedMotion: e.target.checked }))}
                    style={{ width: 22, height: 22, minWidth: 22, marginTop: 2, accentColor: "#ff6800" }}
                  />
                  <div>
                    <span style={{ fontWeight: 600 }}>Reduce motion and animations</span>
                    <p style={{ fontSize: "1rem", color: "#666", marginTop: "4px", marginBottom: 0 }}>
                      Minimizes animations for users sensitive to motion
                    </p>
                  </div>
                </label>
              </div>
            </ConfigSection>

            {/* Language */}
            <ConfigSection
              id="language"
              icon={Globe}
              title="Language"
              expanded={expandedConfigSections.language}
              onToggle={() => setExpandedConfigSections(prev => ({ ...prev, language: !prev.language }))}
            >
              <div className="form-group">
                <label htmlFor="language">Language</label>
                <select
                  id="language"
                  className="form-control"
                  value={userSettings.language}
                  onChange={(e) => setUserSettings(prev => ({ ...prev, language: e.target.value }))}
                >
                  {LANGUAGES.map((lang) => (
                    <option key={lang.code} value={lang.code}>{lang.name}</option>
                  ))}
                </select>
              </div>
              <p style={{ fontSize: "14px", color: "#666", marginTop: "8px" }}>
                Language changes take effect after refreshing the app
              </p>
            </ConfigSection>

            {/* Collaboration (admin only) */}
            {isAdmin && (
              <ConfigSection
                id="collaboration"
                icon={Users}
                title="Collaboration"
                expanded={expandedConfigSections.collaboration}
                onToggle={() => setExpandedConfigSections(prev => ({ ...prev, collaboration: !prev.collaboration }))}
              >
                <div className="form-group" style={{ marginBottom: "16px" }}>
                  <label style={{ display: "flex", alignItems: "flex-start", gap: "12px", cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={tenantData.show_in_collab_directory}
                      onChange={(e) => toggleCollabDirectory(e.target.checked)}
                      style={{ width: 22, height: 22, minWidth: 22, marginTop: 2, accentColor: "#ff6800" }}
                    />
                    <div>
                      <span style={{ fontWeight: 600 }}>Show in collaboration directory</span>
                      <p style={{ fontSize: "1rem", color: "#666", marginTop: "4px", marginBottom: 0 }}>
                        Allow other tenants to discover and collaborate with you
                      </p>
                    </div>
                  </label>
                </div>

                <div className="form-group">
                  <label>Search for tenants to collaborate with</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by name or email..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      if (e.target.value.length >= 3) searchTenants(e.target.value);
                      else setSearchResults([]);
                    }}
                  />
                  {searchQuery.length > 0 && searchQuery.length < 3 && (
                    <small style={{ color: "#888", marginTop: "4px", display: "block" }}>
                      Enter at least 3 characters to search
                    </small>
                  )}
                  {searchQuery.length >= 3 && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => searchTenants(searchQuery)}
                      disabled={searching}
                      style={{ width: "100%", marginTop: "8px" }}
                    >
                      {searching ? "Searching..." : "Search"}
                    </button>
                  )}
                </div>

                {searchResults.length > 0 && (
                  <div style={{ marginTop: "16px", border: "1px solid #e5e7eb", borderRadius: "8px", maxHeight: "300px", overflowY: "auto" }}>
                    {searchResults.map((t) => (
                      <div key={t.id} style={{ padding: "12px", borderBottom: "1px solid #e5e7eb", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div>
                          <div style={{ fontWeight: "600" }}>{t.name}</div>
                          <div style={{ fontSize: "12px", color: "#666" }}>{t.email}</div>
                        </div>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => { setStatus(`Invite functionality coming soon for ${t.name}`); setTimeout(() => setStatus(""), 3000); }}
                        >
                          Invite
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                {searchQuery.length >= 3 && searchResults.length === 0 && !searching && (
                  <p style={{ marginTop: "12px", color: "#666", fontSize: "14px", textAlign: "center" }}>
                    No tenants found matching "{searchQuery}"
                  </p>
                )}
              </ConfigSection>
            )}

            {/* Public Event History (admin only) */}
            {isAdmin && (
              <ConfigSection
                id="publicHistory"
                icon={Globe}
                title="Public Event History"
                expanded={expandedConfigSections.publicHistory}
                onToggle={() => setExpandedConfigSections(prev => ({ ...prev, publicHistory: !prev.publicHistory }))}
              >
                {/* Make Event History Public */}
                <div className="form-group" style={{ marginBottom: "16px" }}>
                  <label style={{ display: "flex", alignItems: "flex-start", gap: "12px", cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={!!tenantData.public_event_history_enabled}
                      onChange={(e) => setTenantData(prev => ({ ...prev, public_event_history_enabled: e.target.checked }))}
                      disabled={busy}
                      style={{ width: 22, height: 22, minWidth: 22, marginTop: 2, accentColor: "#ff6800" }}
                    />
                    <div>
                      <span style={{ fontWeight: 600 }}>Make Event History Public</span>
                      <p style={{ fontSize: "1rem", color: "#666", marginTop: "4px", marginBottom: 0 }}>
                        Allow anyone to view your event history at a public URL
                      </p>
                    </div>
                  </label>
                </div>

                {/* Require Member Login */}
                {tenantData.public_event_history_enabled && (
                  <div className="form-group" style={{ marginBottom: "16px" }}>
                    <label style={{ display: "flex", alignItems: "flex-start", gap: "12px", cursor: "pointer" }}>
                      <input
                        type="checkbox"
                        checked={!!tenantData.public_history_require_login}
                        onChange={(e) => setTenantData(prev => ({ ...prev, public_history_require_login: e.target.checked }))}
                        disabled={busy}
                        style={{ width: 22, height: 22, minWidth: 22, marginTop: 2, accentColor: "#ff6800" }}
                      />
                      <div>
                        <span style={{ fontWeight: 600 }}>Require Member Login</span>
                        <p style={{ fontSize: "1rem", color: "#666", marginTop: "4px", marginBottom: 0 }}>
                          Members must sign in to view the event history
                        </p>
                      </div>
                    </label>
                  </div>
                )}

                {/* Allow Likes */}
                {tenantData.public_event_history_enabled && (
                  <div className="form-group" style={{ marginBottom: "16px" }}>
                    <label style={{ display: "flex", alignItems: "flex-start", gap: "12px", cursor: "pointer" }}>
                      <input
                        type="checkbox"
                        checked={!!tenantData.public_history_allow_likes}
                        onChange={(e) => setTenantData(prev => ({ ...prev, public_history_allow_likes: e.target.checked }))}
                        disabled={busy}
                        style={{ width: 22, height: 22, minWidth: 22, marginTop: 2, accentColor: "#ff6800" }}
                      />
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <Heart size={16} color="#ff6800" />
                        <div>
                          <span style={{ fontWeight: 600 }}>Allow Likes</span>
                          <p style={{ fontSize: "1rem", color: "#666", marginTop: "4px", marginBottom: 0 }}>
                            Members can like media on the public event history page
                          </p>
                        </div>
                      </div>
                    </label>
                  </div>
                )}

                {/* Allow Comments */}
                {tenantData.public_event_history_enabled && (
                  <div className="form-group" style={{ marginBottom: "16px" }}>
                    <label style={{ display: "flex", alignItems: "flex-start", gap: "12px", cursor: "pointer" }}>
                      <input
                        type="checkbox"
                        checked={!!tenantData.public_history_allow_comments}
                        onChange={(e) => setTenantData(prev => ({ ...prev, public_history_allow_comments: e.target.checked }))}
                        disabled={busy}
                        style={{ width: 22, height: 22, minWidth: 22, marginTop: 2, accentColor: "#ff6800" }}
                      />
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <MessageCircle size={16} color="#ff6800" />
                        <div>
                          <span style={{ fontWeight: 600 }}>Allow Comments</span>
                          <p style={{ fontSize: "1rem", color: "#666", marginTop: "4px", marginBottom: 0 }}>
                            Members can comment on media on the public event history page
                          </p>
                        </div>
                      </div>
                    </label>
                  </div>
                )}

                {/* Access Fee */}
                {tenantData.public_event_history_enabled && tenantData.public_history_require_login && (
                  <div className="form-group" style={{ marginBottom: "16px" }}>
                    <label htmlFor="accessFee">Access Fee (USD)</label>
                    <div style={{ position: "relative", maxWidth: "160px", marginTop: "6px" }}>
                      <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", fontSize: "1rem", fontWeight: 600, pointerEvents: "none", color: "#ccc" }}>$</span>
                      <input
                        id="accessFee"
                        type="number"
                        min="0"
                        step="0.01"
                        className="form-control"
                        style={{ paddingLeft: 28 }}
                        value={tenantData.public_history_access_fee || ''}
                        onChange={(e) => setTenantData(prev => ({ ...prev, public_history_access_fee: e.target.value }))}
                        placeholder="0.00"
                        disabled={busy}
                      />
                    </div>
                    <p style={{ fontSize: "1rem", color: "#666", marginTop: "6px" }}>
                      Set to 0 for free access with login. Set a fee to charge members for access.
                    </p>
                  </div>
                )}

                {/* Copy-pastable Event History Link */}
                {tenantData.public_event_history_enabled && (
                  <div className="form-group" style={{ marginBottom: "0" }}>
                    <label>Event History Link</label>
                    <div
                      onClick={() => {
                        const url = `${window.location.origin}/${tenant}/publiceventhistory`;
                        navigator.clipboard.writeText(url).then(() => {
                          setStatus("Link copied to clipboard!");
                          setTimeout(() => setStatus(""), 3000);
                        }).catch(() => {});
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "6px",
                        padding: "8px 12px",
                        backgroundColor: "#0f0f1a",
                        border: "1px solid #333",
                        borderRadius: 6,
                        cursor: "pointer",
                        userSelect: "all",
                        wordBreak: "break-all",
                        fontSize: "0.9rem",
                      }}
                    >
                      <span style={{ flex: 1, color: "#ff6800" }}>
                        {`${window.location.origin}/${tenant}/publiceventhistory`}
                      </span>
                      <span style={{ fontSize: "0.8rem", color: "#888", whiteSpace: "nowrap" }}>Click to copy</span>
                    </div>
                  </div>
                )}
              </ConfigSection>
            )}

            {/* Raffles — Sell Entries (admin only) */}
            {isAdmin && (
              <ConfigSection
                id="raffles"
                icon={Ticket}
                title="Raffles"
                expanded={expandedConfigSections.raffles}
                onToggle={() => setExpandedConfigSections(prev => ({ ...prev, raffles: !prev.raffles }))}
              >
                <div className="form-group" style={{ marginBottom: "0" }}>
                  <label style={{ display: "flex", alignItems: "flex-start", gap: "12px", cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={!!tenantData.paid_raffle_entries_enabled}
                      onChange={(e) => setTenantData(prev => ({ ...prev, paid_raffle_entries_enabled: e.target.checked }))}
                      disabled={busy}
                      style={{ width: 22, height: 22, minWidth: 22, marginTop: 2, accentColor: "#ff6800" }}
                    />
                    <div>
                      <span style={{ fontWeight: 600 }}>Sell Raffle Entries</span>
                      <p style={{ fontSize: "1rem", color: "#666", marginTop: "4px", marginBottom: 0 }}>
                        Allow Raffle EventActions to sell entry tickets via Stripe. Each purchased ticket counts as one chance to win.
                      </p>
                    </div>
                  </label>
                </div>
              </ConfigSection>
            )}
          </div>
        )}

        {activeTab === "appearance" && (
          <div>
            <div className="form-group">
              <label>Theme</label>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                {[
                  { value: "light",   label: "Light",   icon: Sun },
                  { value: "dark",    label: "Dark",    icon: Moon },
                  { value: "minimal", label: "Minimal", icon: Sparkles },
                  { value: "system",  label: "System",  icon: Monitor },
                ].map(({ value, label, icon: Icon }) => (
                  <button
                    key={value}
                    type="button"
                    onClick={() => handleThemeChange(value)}
                    className={`btn ${userSettings.theme === value ? "btn-primary" : "btn-outline-primary"}`}
                    style={{ flex: "0 0 calc(50% - 5px)", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
                  >
                    <Icon style={{ width: "16px", height: "16px" }} />
                    {label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === "security" && (
          <div>
            <div className="form-group" style={{ marginBottom: "20px" }}>
              <label style={{ display: "flex", alignItems: "flex-start", gap: "12px", cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={userSettings.requiremfa}
                  onChange={(e) => setUserSettings(prev => ({ ...prev, requiremfa: e.target.checked }))}
                  style={{ width: 22, height: 22, minWidth: 22, marginTop: 2, accentColor: "#ff6800" }}
                />
                <div>
                  <span style={{ fontWeight: 600 }}>Enable Multi-Factor Authentication (MFA) for my account</span>
                  <p style={{ fontSize: "1rem", color: "#666", marginTop: "4px", marginBottom: 0 }}>
                    Add an extra layer of security to your account
                  </p>
                </div>
              </label>
            </div>
            <div className="form-group" style={{ marginTop: "20px" }}>
              <h4 style={{ fontSize: "16px", marginBottom: "10px" }}>Password</h4>
              <button
                type="button"
                className="btn btn-outline-primary"
                aria-expanded={showChangePassword}
                aria-controls="change-password-panel"
                onClick={() => setShowChangePassword((v) => !v)}
              >
                {showChangePassword ? "Cancel" : "Change Password"}
              </button>
              {showChangePassword && (
                <div id="change-password-panel" style={{ marginTop: "16px" }}>
                  <ChangePasswordForm />
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === "company" && isAdmin && (
          <div>
            <div className="form-group">
              <label htmlFor="companyname">Company Name *</label>
              <input id="companyname" type="text" className="form-control"
                value={tenantData.companyname || ""}
                onChange={(e) => setTenantData(prev => ({ ...prev, companyname: e.target.value }))}
                disabled={busy} />
            </div>
            <div className="form-group">
              <label htmlFor="email">Company Email *</label>
              <input id="email" type="email" className="form-control"
                value={tenantData.email || ""}
                onChange={(e) => setTenantData(prev => ({ ...prev, email: e.target.value }))}
                disabled={busy} />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input id="phone" type="tel" className="form-control"
                value={tenantData.phone || ""}
                onChange={(e) => setTenantData(prev => ({ ...prev, phone: e.target.value }))}
                disabled={busy} />
            </div>
            <div className="form-group">
              <label htmlFor="address1">Address Line 1</label>
              <input id="address1" type="text" className="form-control"
                value={tenantData.address1 || ""}
                onChange={(e) => setTenantData(prev => ({ ...prev, address1: e.target.value }))}
                disabled={busy} />
            </div>
            <div className="form-group">
              <label htmlFor="address2">Address Line 2</label>
              <input id="address2" type="text" className="form-control"
                value={tenantData.address2 || ""}
                onChange={(e) => setTenantData(prev => ({ ...prev, address2: e.target.value }))}
                disabled={busy} />
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "10px" }}>
              <div className="form-group">
                <label htmlFor="city">City</label>
                <input id="city" type="text" className="form-control"
                  value={tenantData.city || ""}
                  onChange={(e) => setTenantData(prev => ({ ...prev, city: e.target.value }))}
                  disabled={busy} />
              </div>
              <div className="form-group">
                <label htmlFor="state">State</label>
                <input id="state" type="text" className="form-control"
                  value={tenantData.state || ""}
                  onChange={(e) => setTenantData(prev => ({ ...prev, state: e.target.value }))}
                  disabled={busy} />
              </div>
              <div className="form-group">
                <label htmlFor="zip">ZIP</label>
                <input id="zip" type="text" className="form-control"
                  value={tenantData.zip || ""}
                  onChange={(e) => setTenantData(prev => ({ ...prev, zip: e.target.value }))}
                  disabled={busy} />
              </div>
            </div>

            <div className="form-group" style={{ marginTop: "16px" }}>
              <label htmlFor="currency">Currency</label>
              <select
                id="currency"
                className="form-control"
                value={tenantData.currency || DEFAULT_CURRENCY}
                onChange={(e) => setTenantData(prev => ({ ...prev, currency: e.target.value }))}
                disabled={busy}
              >
                {currencyOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
              <p className="text-muted" style={{ fontSize: "0.85rem", marginTop: "4px" }}>
                Used for displaying prices and processing payments across this tenant.
              </p>
            </div>

            <hr style={{ margin: "24px 0", border: "none", borderTop: "1px solid #e5e7eb" }} />

            <p className="text-muted" style={{ fontSize: "0.9rem", marginBottom: "16px" }}>
              Public event history settings have moved to the <strong>Configurations</strong> tab.
            </p>

            <hr style={{ margin: "24px 0", border: "none", borderTop: "1px solid #e5e7eb" }} />

            {/* Files & Images */}
            <div className="form-group" style={{ marginBottom: "20px" }}>
              <label style={{ display: "flex", alignItems: "center", gap: 8, fontWeight: 600 }}>
                <Paperclip size={16} /> Files &amp; Images
              </label>
              <p className="text-muted" style={{ fontSize: "0.9rem", marginTop: "4px", marginBottom: "12px" }}>
                Upload images or documents (JPEG, PNG, GIF, WEBP, PDF, DOC, DOCX). Max 10MB per file.
              </p>

              <label
                onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                onDragLeave={() => setDragOver(false)}
                onDrop={(e) => {
                  e.preventDefault();
                  setDragOver(false);
                  if (e.dataTransfer?.files?.length) uploadTenantFiles(e.dataTransfer.files);
                }}
                style={{
                  width: "100%", boxSizing: "border-box", textAlign: "center",
                  display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                  gap: 8, padding: "20px", borderRadius: 8, cursor: filesBusy ? "wait" : "pointer",
                  border: `2px dashed ${dragOver ? "#ff6800" : "#94a3b8"}`,
                  backgroundColor: dragOver ? "rgba(255,104,0,0.08)" : "rgba(255,255,255,0.03)",
                  opacity: filesBusy ? 0.6 : 1, marginBottom: 16,
                  marginLeft: "auto", marginRight: "auto",
                }}
              >
                <Upload size={28} />
                <span className="text-muted" style={{ fontWeight: 500 }}>
                  {filesBusy ? "Uploading…" : "Drop files here or click to browse"}
                </span>
                <input
                  type="file"
                  multiple
                  accept="image/jpeg,image/png,image/gif,image/webp,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  onChange={(e) => { uploadTenantFiles(e.target.files); e.target.value = ""; }}
                  disabled={filesBusy}
                  style={{ display: "none" }}
                />
              </label>

              {tenantFiles.length === 0 ? (
                <p className="text-muted" style={{ fontSize: "0.9rem", textAlign: "center", padding: "12px 0" }}>
                  No files uploaded yet.
                </p>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {tenantFiles.map(f => {
                    const fileUrl = `${baseUrl}/public${f.path}`;
                    const isImg = isImageType(f.type);
                    return (
                      <div key={f.id}
                        style={{
                          display: "flex", alignItems: "center", gap: 12,
                          padding: "10px 12px", border: "1px solid #e5e7eb", borderRadius: 8,
                          backgroundColor: "#fafafa",
                        }}
                      >
                        <div style={{
                          width: 44, height: 44, flexShrink: 0, borderRadius: 6, overflow: "hidden",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          backgroundColor: "#fff", border: "1px solid #e5e7eb",
                        }}>
                          {isImg ? (
                            <img src={fileUrl} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                          ) : (
                            <FileText size={22} color="#64748b" />
                          )}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <a href={fileUrl} target="_blank" rel="noopener noreferrer"
                            style={{ fontWeight: 500, color: "#253866", textDecoration: "none",
                              display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                            title={displayFileName(f.path)}
                          >
                            {displayFileName(f.path)}
                          </a>
                          <div style={{ fontSize: "0.75rem", color: "#64748b" }}>
                            {f.type} • {new Date(f.modifiedon || f.createdon).toLocaleDateString()}
                          </div>
                        </div>
                        <label
                          title="Replace file"
                          className="bg-white"
                          style={{
                            display: "inline-flex", alignItems: "center", gap: 4,
                            padding: "6px 10px", borderRadius: 6, cursor: filesBusy ? "wait" : "pointer",
                            border: "1px solid #cbd5e1",
                            fontSize: "0.8rem", color: "#334155",
                          }}
                        >
                          <Replace size={14} /> Replace
                          <input
                            type="file"
                            accept="image/jpeg,image/png,image/gif,image/webp,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              e.target.value = "";
                              if (file) { setReplacingFileId(f.id); replaceTenantFile(f.id, file); }
                            }}
                            disabled={filesBusy}
                            style={{ display: "none" }}
                          />
                        </label>
                        <button
                          type="button"
                          onClick={() => deleteTenantFile(f.id)}
                          disabled={filesBusy}
                          title="Delete file"
                          style={{
                            display: "inline-flex", alignItems: "center", gap: 4,
                            padding: "6px 10px", borderRadius: 6, cursor: filesBusy ? "wait" : "pointer",
                            border: "1px solid #fecaca", backgroundColor: "#fff",
                            fontSize: "0.8rem", color: "#b91c1c",
                          }}
                        >
                          <Trash2 size={14} /> Delete
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === "transactions" && isAdmin && (
          <TenantTransactions tenant={tenant} />
        )}

        {activeTab === "roleAccess" && isAdmin && (
          <div>
            <h4 style={{ fontSize: "16px", marginBottom: "4px" }}>Role-Based Access Control</h4>
            <p className="text-muted" style={{ fontSize: "0.9rem", marginBottom: "20px" }}>
              Configure what each role can do across your organization. Select a role to view and edit its permissions.
            </p>

            {/* Role Selector */}
            <div className="form-group" style={{ marginBottom: "20px" }}>
              <label htmlFor="roleSelector" style={{ fontWeight: 600, fontSize: "14px" }}>Select Role</label>
              <select
                id="roleSelector"
                className="form-control"
                style={{ maxWidth: "240px", marginTop: "6px", textTransform: "capitalize" }}
                value={selectedRole}
                onChange={(e) => setSelectedRole(e.target.value)}
              >
                {ROLES.map(role => (
                  <option key={role} value={role} style={{ textTransform: "capitalize" }}>
                    {role.charAt(0).toUpperCase() + role.slice(1)}
                  </option>
                ))}
              </select>
            </div>

            {/* Owner notice */}
            {selectedRole === 'owner' && (
              <div style={{
                padding: "12px 16px", borderRadius: "8px", marginBottom: "20px",
                backgroundColor: "rgba(5, 42, 128, 0.06)", border: "1px solid rgba(5, 42, 128, 0.15)",
                fontSize: "0.85rem", color: "#253866",
              }}>
                <strong>Owner</strong> has full access to all resources and cannot be modified.
              </div>
            )}

            {/* Bulk Actions (non-owner) */}
            {selectedRole !== 'owner' && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "16px", flexWrap: "wrap" }}>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => {
                    setRolePermissions(prev => {
                      const next = { ...prev, [selectedRole]: { ...prev[selectedRole] } };
                      for (const res of ALL_RESOURCES) {
                        next[selectedRole][res.key] = {};
                        for (const action of res.actions) next[selectedRole][res.key][action] = true;
                      }
                      return next;
                    });
                  }}
                >
                  Grant All
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => {
                    setRolePermissions(prev => {
                      const next = { ...prev, [selectedRole]: { ...prev[selectedRole] } };
                      for (const res of ALL_RESOURCES) {
                        next[selectedRole][res.key] = {};
                        for (const action of res.actions) next[selectedRole][res.key][action] = false;
                      }
                      return next;
                    });
                  }}
                >
                  Revoke All
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  style={{ marginLeft: "auto" }}
                  onClick={() => {
                    const defaults = buildDefaultPermissions();
                    setRolePermissions(prev => ({ ...prev, [selectedRole]: defaults[selectedRole] }));
                  }}
                >
                  Reset to Defaults
                </button>
              </div>
            )}

            {/* Permission Matrix by Section */}
            {RESOURCE_SECTIONS.map(section => {
              const isExpanded = expandedSections[section.label];
              return (
                <div key={section.label} style={{
                  marginBottom: "12px", border: "1px solid #e5e7eb", borderRadius: "8px", overflow: "hidden",
                }}>
                  {/* Section Header */}
                  <button
                    type="button"
                    onClick={() => setExpandedSections(prev => ({ ...prev, [section.label]: !prev[section.label] }))}
                    className="bg-light"
                    style={{
                      width: "100%", display: "flex", alignItems: "center", gap: "8px",
                      padding: "12px 16px", border: "none", cursor: "pointer",
                      color: "#253866",
                      fontWeight: 600, fontSize: "14px", textAlign: "left",
                    }}
                  >
                    {isExpanded
                      ? <ChevronDown style={{ width: 16, height: 16, flexShrink: 0 }} />
                      : <ChevronRight style={{ width: 16, height: 16, flexShrink: 0 }} />}
                    {section.label}
                    <span style={{ marginLeft: "auto", fontSize: "12px", fontWeight: 400, color: "#888" }}>
                      {section.resources.length} resource{section.resources.length > 1 ? 's' : ''}
                    </span>
                  </button>

                  {/* Resource Rows */}
                  {isExpanded && (
                    <div>
                      {section.resources.map((res, idx) => {
                        const perms = rolePermissions[selectedRole]?.[res.key] || {};
                        const allGranted = res.actions.every(a => perms[a]);
                        const noneGranted = res.actions.every(a => !perms[a]);
                        return (
                          <div key={res.key} style={{
                            padding: "12px 16px",
                            borderTop: idx === 0 ? "1px solid #e5e7eb" : "1px solid #f3f4f6",
                          }}>
                            {/* Resource name + row toggle */}
                            <div style={{
                              display: "flex", alignItems: "center", justifyContent: "space-between",
                              marginBottom: "8px",
                            }}>
                              <span style={{ fontWeight: 600, fontSize: "13px" }}>{res.label}</span>
                              {selectedRole !== 'owner' && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    const grantAll = !allGranted;
                                    setRolePermissions(prev => {
                                      const next = { ...prev, [selectedRole]: { ...prev[selectedRole] } };
                                      next[selectedRole][res.key] = {};
                                      for (const a of res.actions) next[selectedRole][res.key][a] = grantAll;
                                      return next;
                                    });
                                  }}
                                  style={{
                                    border: "none", background: "none", cursor: "pointer",
                                    fontSize: "11px", color: allGranted ? "#ef4444" : "#059669",
                                    fontWeight: 500, padding: "2px 6px", borderRadius: "4px",
                                  }}
                                >
                                  {allGranted ? "Revoke All" : "Grant All"}
                                </button>
                              )}
                            </div>

                            {/* Action Toggles */}
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                              {res.actions.map(action => {
                                const granted = !!perms[action];
                                const isOwner = selectedRole === 'owner';
                                return (
                                  <button
                                    key={action}
                                    type="button"
                                    disabled={isOwner}
                                    onClick={() => {
                                      setRolePermissions(prev => {
                                        const next = { ...prev, [selectedRole]: { ...prev[selectedRole] } };
                                        next[selectedRole][res.key] = { ...prev[selectedRole][res.key], [action]: !granted };
                                        return next;
                                      });
                                    }}
                                    style={{
                                      display: "inline-flex", alignItems: "center", gap: "4px",
                                      padding: "4px 10px", borderRadius: "16px", fontSize: "12px",
                                      fontWeight: 500, cursor: isOwner ? "default" : "pointer",
                                      border: granted ? "1px solid #059669" : "1px solid #d1d5db",
                                      backgroundColor: granted ? "rgba(5, 150, 105, 0.08)" : "transparent",
                                      color: granted ? "#059669" : "#9ca3af",
                                      opacity: isOwner ? 0.7 : 1,
                                      transition: "all 0.15s ease",
                                    }}
                                  >
                                    {granted
                                      ? <Check style={{ width: 12, height: 12 }} />
                                      : <X style={{ width: 12, height: 12 }} />}
                                    {ACTION_LABELS[action] || action}
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}

            {/* Role summary */}
            <div className="bg-light" style={{
              marginTop: "20px", padding: "12px 16px", borderRadius: "8px",
              fontSize: "0.85rem", color: "#555",
            }}>
              <strong>Role summary — {selectedRole.charAt(0).toUpperCase() + selectedRole.slice(1)}:</strong>
              <div style={{ marginTop: "6px" }}>
                {(() => {
                  const perms = rolePermissions[selectedRole] || {};
                  const granted = ALL_RESOURCES.reduce((sum, r) => sum + r.actions.filter(a => perms[r.key]?.[a]).length, 0);
                  const total = ALL_RESOURCES.reduce((sum, r) => sum + r.actions.length, 0);
                  const pct = Math.round((granted / total) * 100);
                  return (
                    <>
                      <div style={{
                        height: "6px", borderRadius: "3px", backgroundColor: "#e5e7eb",
                        marginBottom: "6px", overflow: "hidden",
                      }}>
                        <div style={{
                          height: "100%", borderRadius: "3px", width: `${pct}%`,
                          backgroundColor: pct === 100 ? "#059669" : pct > 50 ? "#f59e0b" : "#ef4444",
                          transition: "width 0.3s ease",
                        }} />
                      </div>
                      <span>{granted} of {total} permissions granted ({pct}%)</span>
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
        )}

        {activeTab === "payments" && isAdmin && (
          <div>
            <PaymentProviderSettings tenantId={tenantData?.id || tenant} />

            <div style={{ marginTop: "24px", padding: "16px", border: "1px solid #e5e7eb", borderRadius: "8px", background: "#fff", color: "#1f2937" }}>
              <label style={{ display: "flex", alignItems: "center", gap: "10px", fontWeight: 600, fontSize: "16px", cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={!!tenantData.tax_collection_enabled}
                  onChange={(e) => setTenantData(prev => ({ ...prev, tax_collection_enabled: e.target.checked }))}
                  disabled={busy}
                />
                Automatic sales tax (Stripe Tax)
              </label>
              <p style={{ fontSize: "13px", color: "#666", marginTop: "10px", marginBottom: 0 }}>
                Calculates and records sales tax/VAT on ticket purchases based on the buyer's location.
                Requires Stripe Tax to be set up on your Stripe account first — configure your origin
                address and tax registrations at{" "}
                <a href="https://dashboard.stripe.com/tax/registrations" target="_blank" rel="noopener noreferrer" style={{ color: "#ff6800" }}>
                  dashboard.stripe.com/tax
                </a>. You're responsible for determining and remitting your own tax obligations —
                turning this on only automates the calculation at checkout, not registration or filing.
                If Stripe Tax isn't configured yet, checkout still works — tax is simply skipped.
              </p>
            </div>

            <h4 style={{ fontSize: "16px", marginTop: "32px", marginBottom: "16px", color: "#008CFF" }}>Venmo</h4>

            {/* Section 1: Venmo via Stripe */}
            <div style={{ marginBottom: "24px", padding: "16px", border: "1px solid #e5e7eb", borderRadius: "8px" }}>
              <div className="form-group" style={{ marginBottom: "12px" }}>
                <label style={{ display: "flex", alignItems: "flex-start", gap: "12px", cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={!!tenantData.venmo_stripe_enabled}
                    onChange={(e) => setTenantData(prev => ({ ...prev, venmo_stripe_enabled: e.target.checked }))}
                    disabled={busy}
                    style={{ width: 22, height: 22, minWidth: 22, marginTop: 2, accentColor: "#ff6800" }}
                  />
                  <div>
                    <span style={{ fontWeight: 600 }}>Enable Venmo via Stripe</span>
                    <p style={{ fontSize: "1rem", color: "#666", marginTop: "4px", marginBottom: 0 }}>
                      Allow customers to pay with Venmo through Stripe checkout (subscriptions & member access fees). US customers only.
                    </p>
                  </div>
                </label>
              </div>
            </div>

            {/* Section 2: Direct Venmo */}
            <div style={{ marginBottom: "24px", padding: "16px", border: "1px solid #e5e7eb", borderRadius: "8px" }}>
              <div className="form-group" style={{ marginBottom: "12px" }}>
                <label style={{ display: "flex", alignItems: "flex-start", gap: "12px", cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={!!tenantData.venmo_direct_enabled}
                    onChange={(e) => setTenantData(prev => ({ ...prev, venmo_direct_enabled: e.target.checked }))}
                    disabled={busy}
                    style={{ width: 22, height: 22, minWidth: 22, marginTop: 2, accentColor: "#ff6800" }}
                  />
                  <div>
                    <span style={{ fontWeight: 600 }}>Enable Direct Venmo Payments</span>
                    <p style={{ fontSize: "1rem", color: "#666", marginTop: "4px", marginBottom: 0 }}>
                      Accept payments directly via PayPal/Venmo API for event access fees, tips, etc.
                    </p>
                  </div>
                </label>
              </div>

              {tenantData.venmo_direct_enabled && (
                <div style={{ marginLeft: "30px", marginTop: "12px" }}>
                  <div className="form-group" style={{ marginBottom: "12px" }}>
                    <label htmlFor="venmoUsername">Venmo Username</label>
                    <input
                      id="venmoUsername"
                      type="text"
                      className="form-control"
                      placeholder="@your-venmo-username"
                      value={tenantData.venmo_username || ""}
                      onChange={(e) => setTenantData(prev => ({ ...prev, venmo_username: e.target.value }))}
                      disabled={busy}
                    />
                  </div>
                  <div className="form-group" style={{ marginBottom: "12px" }}>
                    <label htmlFor="venmoDisplayName">Display Name</label>
                    <input
                      id="venmoDisplayName"
                      type="text"
                      className="form-control"
                      placeholder="Your business or display name"
                      value={tenantData.venmo_display_name || ""}
                      onChange={(e) => setTenantData(prev => ({ ...prev, venmo_display_name: e.target.value }))}
                      disabled={busy}
                    />
                    <p style={{ fontSize: "12px", color: "#888", marginTop: "4px" }}>
                      Shown to customers on the payment button. Defaults to company name.
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* Section 3: Venmo Event Button */}
            <div style={{ marginBottom: "24px", padding: "16px", border: "1px solid #e5e7eb", borderRadius: "8px" }}>
              <div className="form-group" style={{ marginBottom: "12px" }}>
                <label style={{ display: "flex", alignItems: "flex-start", gap: "12px", cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={!!tenantData.venmo_event_button_enabled}
                    onChange={(e) => setTenantData(prev => ({ ...prev, venmo_event_button_enabled: e.target.checked }))}
                    disabled={busy}
                    style={{ width: 22, height: 22, minWidth: 22, marginTop: 2, accentColor: "#ff6800" }}
                  />
                  <div>
                    <span style={{ fontWeight: 600 }}>Show Venmo Button on Event Pages</span>
                    <p style={{ fontSize: "1rem", color: "#666", marginTop: "4px", marginBottom: 0 }}>
                      Display a "Pay with Venmo" button on your public event pages so attendees can pay or tip directly.
                    </p>
                  </div>
                </label>
              </div>

              {tenantData.venmo_event_button_enabled && (
                <div style={{ marginLeft: "30px", marginTop: "12px" }}>
                  {!tenantData.venmo_username && (
                    <p style={{ fontSize: "13px", color: "#ef4444", marginBottom: "12px" }}>
                      A Venmo username is required. Please enable "Direct Venmo Payments" above and enter your username.
                    </p>
                  )}
                  <div className="form-group" style={{ marginBottom: "12px" }}>
                    <label htmlFor="venmoDefaultNote">Default Payment Note</label>
                    <input
                      id="venmoDefaultNote"
                      type="text"
                      className="form-control"
                      placeholder="e.g., Event admission, Tip, Donation"
                      value={tenantData.venmo_default_note || ""}
                      onChange={(e) => setTenantData(prev => ({ ...prev, venmo_default_note: e.target.value }))}
                      disabled={busy}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="venmoDefaultAmount">Suggested Amount (USD)</label>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
                      <span style={{ fontSize: "1.1rem", fontWeight: 600 }}>$</span>
                      <input
                        id="venmoDefaultAmount"
                        type="number"
                        min="0"
                        step="0.01"
                        className="form-control"
                        style={{ maxWidth: "140px" }}
                        value={tenantData.venmo_default_amount || ''}
                        onChange={(e) => setTenantData(prev => ({ ...prev, venmo_default_amount: e.target.value }))}
                        placeholder="0.00"
                        disabled={busy}
                      />
                    </div>
                    <p style={{ fontSize: "12px", color: "#888", marginTop: "4px" }}>
                      Leave empty to let attendees choose their own amount.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === "dangerZone" && isOwner && (
          <div>
            <div style={{ padding: "16px", border: "1px solid #dc3545", borderRadius: "8px", marginBottom: "24px" }}>
              <h4 style={{ fontSize: "16px", marginBottom: "8px", color: "#dc3545" }}>
                Delete This Business
              </h4>
              <p style={{ fontSize: "0.9rem", color: "#666", marginBottom: "16px" }}>
                Permanently deactivates this business account and cancels its subscription immediately. All users lose access. This cannot be undone from the app.
              </p>
              <div className="form-group" style={{ marginBottom: "12px" }}>
                <label htmlFor="tenantDeleteConfirm">
                  Type <strong>{tenantData.companyname}</strong> to confirm
                </label>
                <input
                  id="tenantDeleteConfirm"
                  type="text"
                  className="form-control"
                  value={tenantDeleteConfirm}
                  onChange={(e) => setTenantDeleteConfirm(e.target.value)}
                  disabled={tenantDeleteBusy}
                />
              </div>
              <div className="form-group" style={{ marginBottom: "12px" }}>
                <label htmlFor="tenantDeletePassword">Your password</label>
                <input
                  id="tenantDeletePassword"
                  type="password"
                  className="form-control"
                  value={tenantDeletePassword}
                  onChange={(e) => setTenantDeletePassword(e.target.value)}
                  disabled={tenantDeleteBusy}
                />
              </div>
              <button
                type="button"
                className="btn btn-danger"
                disabled={tenantDeleteBusy || tenantDeleteConfirm !== tenantData.companyname || !tenantDeletePassword}
                onClick={handleDeleteTenant}
              >
                {tenantDeleteBusy ? "Deleting..." : "Delete This Business"}
              </button>
            </div>

            <div style={{ padding: "16px", border: "1px solid #dc3545", borderRadius: "8px" }}>
              <h4 style={{ fontSize: "16px", marginBottom: "8px", color: "#dc3545" }}>
                Delete My Owner Account
              </h4>
              <p style={{ fontSize: "0.9rem", color: "#666", marginBottom: "16px" }}>
                {ownedTenantsCount > 1
                  ? `Permanently deletes your owner account and all ${ownedTenantsCount} businesses you own. This cannot be undone from the app.`
                  : "Permanently deletes your owner account. This cannot be undone from the app."}
              </p>
              <div className="form-group" style={{ marginBottom: "12px" }}>
                <label htmlFor="ownerDeleteConfirm">Type your account email to confirm</label>
                <input
                  id="ownerDeleteConfirm"
                  type="text"
                  className="form-control"
                  value={ownerDeleteConfirm}
                  onChange={(e) => setOwnerDeleteConfirm(e.target.value)}
                  disabled={ownerDeleteBusy}
                />
              </div>
              <div className="form-group" style={{ marginBottom: "12px" }}>
                <label htmlFor="ownerDeletePassword">Your password</label>
                <input
                  id="ownerDeletePassword"
                  type="password"
                  className="form-control"
                  value={ownerDeletePassword}
                  onChange={(e) => setOwnerDeletePassword(e.target.value)}
                  disabled={ownerDeleteBusy}
                />
              </div>
              <button
                type="button"
                className="btn btn-danger"
                disabled={ownerDeleteBusy || !ownerDeleteConfirm || !ownerDeletePassword}
                onClick={handleDeleteOwnerAccount}
              >
                {ownerDeleteBusy ? "Deleting..." : "Delete My Owner Account"}
              </button>
            </div>
          </div>
        )}

      </div>

      {/* Footer */}
      <AppFooter
        buttons={[
          { icon: <FaArrowLeft />, label: "Back", onClick: () => navigate(-1) },
          { icon: <FaHome />, label: "Home", onClick: () => navigate(`/${tenant}/dashboard`) },
          {
            icon: busy ? <RefreshCw className="animate-spin" /> : <FaSave />,
            label: busy ? "Saving..." : "Save",
            onClick: handleSave,
            disabled: busy,
          },
        ]}
      />
    </div>
  );
}